
const microhabitsStore = {
	namespaced: true,
	state: {
		currentCategory: null,
		currentMicrohabit: null
	},
	mutations: {
		setCurrentCategory (state, category) {
			state.currentCategory = category
		},
		setCurrentMicrohabit (state, microhabit) {
			state.currentMicrohabit = microhabit
		}
	}
}

export default microhabitsStore


// WEBPACK FOOTER //
// ./src/store/modules/microhabits.js